
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', delay = 0, className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; delay?: number; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation, delay)} ${className}`}>
      {children}
    </div>
  );
}

export default function Stats() {
  const stats = [
    {
      value: '+500',
      label: 'Profesionales activos',
      description: 'usan Anamnesy Soft diariamente',
      image: 'https://readdy.ai/api/search-image?query=team%20of%20ophthalmologists%20and%20eye%20care%20professionals%20working%20together%20in%20modern%20bright%20clinic%20using%20digital%20technology%20emerald%20green%20accent%20colors%20professional%20medical%20environment&width=500&height=350&seq=stat-opht-1&orientation=landscape',
    },
    {
      value: '50K+',
      label: 'Pacientes gestionados',
      description: 'cada mes en la plataforma',
      image: 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20patients%20in%20modern%20ophthalmology%20waiting%20room%20with%20digital%20check%20in%20screens%20bright%20clean%20medical%20facility%20emerald%20green%20accents%20warm%20welcoming%20atmosphere&width=500&height=350&seq=stat-opht-2&orientation=landscape',
    },
    {
      value: '99.9%',
      label: 'Uptime garantizado',
      description: 'disponibilidad continua',
      image: 'https://readdy.ai/api/search-image?query=modern%20cloud%20server%20room%20with%20green%20LED%20lights%20showing%20data%20center%20infrastructure%20for%20healthcare%20technology%20secure%20reliable%20computing%20environment%20dark%20with%20emerald%20green%20glowing%20accents&width=500&height=350&seq=stat-opht-3&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold text-emerald-600 uppercase tracking-widest mb-3">Métricas</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Resultados que <span className="font-display italic text-emerald-600">hablan</span> por sí solos
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <AnimatedSection key={index} animation="scale-in" delay={index * 150}>
              <div className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all cursor-pointer">
                <div className="relative h-72">
                  <img
                    src={stat.image}
                    alt={stat.label}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                    <p className="text-4xl font-bold mb-1">{stat.value}</p>
                    <p className="text-sm font-semibold mb-0.5">{stat.label}</p>
                    <p className="text-xs text-white/70">{stat.description}</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
